import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';

interface DeleteUserFromTeamParams {
  teamId: number;
  userId: number;
}

export const useDeleteUserFromTeam = () => {
  const queryClient = useQueryClient();

  const deleteUserFromTeam = async ({
    teamId,
    userId
  }: DeleteUserFromTeamParams) => {
    const url = DELETE_URL(teamId.toString()).removeUser;
    const response = await Axios.post(url, { user_ids: [userId] });
    return response.data;
  };

  return useMutation(deleteUserFromTeam, {
    onSuccess: () => {
      queryClient.invalidateQueries('teamUsers');
    }
  });
};
